module.exports = __webpack_public_path__ + "img/shop.234202f3.svg";